import React from 'react';
import BlockContainer from './BlockContainer';
import FeatureBlock from './FeatureBlock';

export default function FeatureList({
  title,
  description,
  features,
  bgColor,
  textColor,
  padding,
}) {
  return title || description || features?.length > 0 ? (
    <BlockContainer
      title={title}
      description={description}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      fullWidth
    >
      {features?.length > 0 ? (
        <div className="text-left">
          {features.map((feature, i) => (
            <FeatureBlock key={i} {...feature} />
          ))}
        </div>
      ) : null}
    </BlockContainer>
  ) : null;
}
